import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { setConfig } from '../../actions/config'
import ColorsSection from './ColorsSection'
import '../../css/elements/right-sidebar.css'

class Index extends Component {
  constructor () {
    super()
    this.handleSetNavbar = this.handleSetNavbar.bind(this)
    this.handleSetTopNavigation = this.handleSetTopNavigation.bind(this)
    this.handleSetSidebar = this.handleSetSidebar.bind(this)
    this.setIconColor = this.setIconColor.bind(this)
    this.navbarColors = [
      'light',
      'dark',
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger'
    ]
    this.leftSidebarColors = [
      'light',
      'dark',
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger'
    ]
    this.layouts = [
      {
        url: '/layouts/default-sidebar-1',
        icon: '',
        title: 'Default sidebar',
        items: []
      },
      {
        url: '/layouts/off-canvas-1',
        icon: '',
        title: 'Off canvas',
        items: []
      },
      {
        url: '/layouts/top-navigation-1',
        icon: '',
        title: 'Top navigation',
        items: []
      }
    ]
  }

  handleSetNavbar (color) {
    this.props.setConfig('navbar', color)
  }

  handleSetTopNavigation (color) {
    this.props.setConfig('topNavigation', color)
  }

  handleSetSidebar (color) {
    this.props.setConfig('leftSidebar', color)
  }

  setIconColor (color) {
    this.props.setConfig('logo', color)
  }

  render () {
    if (this.props.config.layout === 'empty-view-1') {
      return (
        <div />
      )
    }
    return (
      <div
        className={
          this.props.rightSidebar
            ? 'right-sidebar-outer show-from-right'
            : 'right-sidebar-outer'
        }
      >
        <div className='right-sidebar-inner'>
          <div className='right-sidebar'>
            <h4>Theme configuration</h4>
            <ul className='list-group unbordered unstriped'>
              <li className='list-group-item text-bold'>
                Layout
              </li>
              {this.layouts.map(({ url, title }, i) =>
                <li className='list-group-item' key={i}>
                  <div className='row'>
                    <div className='col'>
                      <Link to={url}>{title}</Link>
                    </div>
                  </div>
                </li>
              )}
            </ul>
            <ColorsSection title='Navbar color' colors={this.navbarColors} onClick={this.handleSetNavbar} />
            <ColorsSection title='Top navigation color' colors={this.navbarColors} onClick={this.handleSetTopNavigation} />
            <ColorsSection title='Left sidebar color' colors={this.leftSidebarColors} onClick={this.handleSetSidebar} />
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = ({ config, colors, backgroundColors }, ownProps) => ({
  config,
  navbarColors: config.navbarColors,
  leftSidebarColors: config.leftSidebarColors,
  colors,
  backgroundColors,
  rightSidebar: config.rightSidebar
})
const mapDispatchToProps = dispatch => ({
  setConfig: (key, value) => dispatch(setConfig(key, value))
})
export default connect(mapStateToProps, mapDispatchToProps)(Index)



// WEBPACK FOOTER //
// ./src/elements/right-sidebar/Index.js